import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';

import { DataService } from '../../services/data.service';
import { JossoService } from '../../services/josso.service';

@Component({
	selector: 'app-content',
	templateUrl: './content.component.html',
	styleUrls: ['./content.component.css']
})
export class ContentComponent implements OnInit {
	contentHeight: string;
	nativeHeight: number;
	nativeHeightSync: Subscription;

	contentWidth: string;
	nativeWidth: number;
	nativeWidthSync: Subscription;

	constructor(private dataService: DataService, private jossoService: JossoService) {
	}

	ngOnInit() {
		this.jossoService.getSessionCookie();
		this.nativeHeightSync = this.dataService.getCommon().getNativeWindow().nativeHeight$.subscribe(
			nativeHeight => {
				this.nativeHeight = nativeHeight;
				if(!this.nativeHeight || this.nativeHeight < 0){
					this.nativeHeight = 720;
					this.contentWidth = this.nativeWidth + '%';
				}
				this.contentHeight = this.nativeHeight + 'px';
				//console.log("CMP|CONTENT - nativeHeight", this.nativeHeight, this.contentHeight);
			});
		this.nativeWidthSync = this.dataService.getCommon().getNativeWindow().nativeWidth$.subscribe(
			nativeWidth => {
				this.nativeWidth = nativeWidth;
				if(!this.nativeWidth || this.nativeWidth < 1280){
					this.nativeWidth = 1280;
				}else if(this.nativeWidth > 1680){
					this.nativeWidth = 1680;
				}
				this.contentWidth = this.nativeWidth + 'px';
				//console.log("CMP|CONTENT - nativeWidth", this.nativeWidth, this.contentWidth);
			});
	}
}
